document.addEventListener('touchstart', e => {
  const card = e.target.closest('.card-product');
  if (!card) return;
  card.dataset.drag = "0";
});

document.addEventListener('touchmove', e => {
  const card = e.target.closest('.card-product');
  if (!card) return;
  card.dataset.drag = "1";
});

document.addEventListener('click', e => {
  const link = e.target.closest('.card-product a');
  if (!link) return;

  const card = link.closest('.card-product');
  if (card.dataset.drag === "1") {
    e.preventDefault();
  }
});
